import { Navigation, NavItemProps } from "react-minimal-side-navigation";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import routes, { EBaseRoutes, IRouteItemProps } from "../../const/routes";
import { IPrivilege } from "../../interfaces/privilege";
import { IRootState } from "../../store/configureStore";
import hasPrivilege from "../../util/hasPermission";
import Box from "@mui/material/Box";
import logoDark from "../../assets/images/logo-dark.png";
import SideNavigation from "./SideNav";

interface IProps {
  setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

const Sidebar = (props: IProps) => {
  // const navigate = useNavigate();
  // const location = useLocation();

  // const { privileges } = useSelector(({ privileges }: IRootState) => ({
  //   privileges: privileges.dataBundle,
  // }));

  // const getSubRoutes = (
  //   items: IRouteItemProps[],
  //   privileges: IPrivilege[]
  // ): NavItemProps[] => {
  //   return items
  //     .filter((item) => item.isNavBarItem && hasPrivilege(privileges, item.id))
  //     .map((item) => {
  //       return {
  //         title: item.title,
  //         itemId: item.path,
  //       };
  //     });
  // };

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        flexDirection: "column",
        height: "100vh",
      }}
    >
      <Box
        sx={{
          flex: 1,
          marginLeft: "50px",
          marginRight: "50px",
          marginTop: "20px",
          display: { xs: "none", sm: "block" },
        }}
      >
        <img
          src={logoDark}
          alt="Logo"
          className="img-fluid"
          style={{ minHeight: "100px" }}
        />
      </Box>
      <Box
        sx={{
          flex: 6,
          display: "flex",
          flexDirection: "column",
          background: `linear-gradient(45deg,rgb(3, 86, 161),rgb(33, 66, 142))`,
          color: "white",
          paddingTop: "30px",
          borderRadius: "0 20px 0 0",
          overflow: "auto",

          "&::-webkit-scrollbar": {
            width: "5px",
            height: "8px",
          },
          "&::-webkit-scrollbar-track": {
            background: "rgb(3, 86, 161)",
            marginTop: "20px",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "rgba(139, 176, 208, 0.46)",
            borderRadius: "10px",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            background: "#555",
          },
        }}
      >
        {/* <Navigation
          activeItemId={location.pathname}
          items={routes(location)
            .filter(
              (item) =>
                item.subItems.filter((subItem) =>
                  hasPrivilege(privileges, subItem.id)
                ).length
            )
            .map((item) => ({
              title: item.title,
              itemId: item.itemId,
              elemBefore: item.elemBefore,
              subNav: getSubRoutes(item.subItems, privileges),
            }))}
          onSelect={(itemId) => {
            if (
              !Object.values(EBaseRoutes).includes(itemId.itemId as EBaseRoutes)
            ) {
              props.setIsOpen && props.setIsOpen(false);
              navigate(itemId.itemId);
            }
          }}
        /> */}
        <SideNavigation />
      </Box>
    </Box>
  );
};

export default Sidebar;
